module.exports = __webpack_public_path__ + "img/no-question-data.ee1d54c3.svg";